import { MdOutlineEditOff } from 'react-icons/md'

export default function NotFound404({
  title, subTitle
} : { title: string, subTitle: string }) {
  return <div className='flex items-center justify-center w-full px-4 my-12 text-gray-900'>
    <div className='flex flex-col items-center w-full gap-8'>
      <MdOutlineEditOff size={120} className='text-gray-400 '/>
      <p className='text-3xl font-semibold text-center'>{title}</p>
      <p className='text-xl text-center md:px-12 text-muted'>
        {subTitle}
      </p>
    </div>
  </div>
}